import { useState } from "react";
import { Icon } from "../Icon";

/** Monospace value with a copy button (DNS records, IDs, API keys). */
export function CopyField({ value, label }: { value: string; label: string }) {
  const [copied, setCopied] = useState<"idle" | "ok" | "failed">("idle");
  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied("ok");
    } catch {
      setCopied("failed");
    }
    window.setTimeout(() => setCopied("idle"), 2500);
  }
  return (
    <div className="code-block">
      <code aria-label={label}>{value}</code>
      <button type="button" className="btn btn-ghost btn-sm" onClick={copy} aria-label={`Copy ${label}`}>
        <Icon name={copied === "ok" ? "check" : "copy"} />
        <span aria-live="polite">{copied === "ok" ? "Copied" : copied === "failed" ? "Copy failed — select and copy" : "Copy"}</span>
      </button>
    </div>
  );
}

/** Reference ID shown in error states (UX-DESIGN.md §6). */
export function RefId({ label = "Reference", value }: { label?: string; value: string }) {
  return (
    <span className="small">
      {label}: <code className="break-all">{value}</code>
    </span>
  );
}
